/**
 * The wizard steps this package contributes (W2-14 onboarding-wizard; DESIGN.md §4.3): Song (10), Picture (20),
 * Details (30) and Start (50). The Beat step (40) comes from the timing package (W2-08) through the registry; the
 * wizard runs without it (timing then stays unconfirmed and Problems shows tip ST-01).
 */

import type { WizardStepDef } from '../../app/registry/types';
import { DetailsStep } from './steps/DetailsStep';
import { PictureStep } from './steps/PictureStep';
import { SongStep } from './steps/SongStep';
import { StartStep } from './steps/StartStep';
import { m } from './wizard.messages';

export const WIZARD_STEPS: readonly WizardStepDef[] = [
  { id: 'song', order: 10, title: m.stepSong, skippable: false, component: SongStep },
  { id: 'picture', order: 20, title: m.stepPicture, skippable: true, component: PictureStep },
  { id: 'details', order: 30, title: m.stepDetails, skippable: true, component: DetailsStep },
  { id: 'start', order: 50, title: m.stepStart, skippable: false, component: StartStep },
];
